/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

export const elasticSearchMetaSchema = z.object({ "aggregations": z.unknown().nullish(), "currentPage": z.number(), "pageCount": z.number(), "resultCount": z.number(), "searchAfter": z.array(z.string()) });
export type ElasticSearchMeta = z.infer<typeof elasticSearchMetaSchema>;
